export default __webpack_public_path__ + "e4a889cebadfc2103fcd70bfd3891575.svg";